export default __webpack_public_path__ + "static/media/sidebar4.77285ddb.jpg";